<template>
  <v-container>
      <v-responsive class="mx-auto">
        <v-carousel>
          <v-carousel-item eager src="../../assets/mainpage/1.jpg"></v-carousel-item>
          <v-carousel-item eager src="../../assets/mainpage/2.jpg"></v-carousel-item>
          <v-carousel-item eager src="../../assets/mainpage/3.jpg"></v-carousel-item>
          <v-carousel-item eager src="../../assets/mainpage/4.jpg"></v-carousel-item>
          <v-carousel-item eager src="../../assets/mainpage/5.jpg"></v-carousel-item>
          <v-carousel-item eager src="../../assets/mainpage/6.jpg"></v-carousel-item>
          <v-carousel-item eager src="../../assets/mainpage/7.jpg"></v-carousel-item>
          <v-carousel-item eager src="../../assets/mainpage/8.jpg"></v-carousel-item>
          <v-carousel-item eager src="../../assets/mainpage/9.jpg"></v-carousel-item>
          <v-carousel-item eager src="../../assets/mainpage/10.jpg"></v-carousel-item>
        </v-carousel>
    </v-responsive>
  </v-container>
</template>

<script>
export default {
  name: 'HomeMainCarousel',
  data: () => ({
  }),
};
</script>

<style scoped>
#home-carousel {


}

</style>
